/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-03-16T14:44:46-07:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T08:55:03-07:00
*/



import React, { Component } from 'react';
import { spacing } from '../../../style';
import { StyleSheet, css } from 'aphrodite/no-important';
import TextLink from '../../common/TextLink';
import Container from '../../blocks/Container';


const style = StyleSheet.create({
  deactivateBlock: {
    ...spacing.MARGIN_TOP_XL
  }
})

class DeactivateAccount extends Component {
  render() {
    return (
      <div className={css(style.deactivateBlock)}>
        <Container>
          <TextLink color='red' to="/deactivate">Deactivate Your Account</TextLink>
        </Container>
      </div>
    );
  }
}

export default DeactivateAccount;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/DeactivateAccount.jsx